module.exports = __webpack_public_path__ + "img/img-user-profile.153a02b8.png";